'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _lodash = require('lodash');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Filter = function (_React$Component) {
  _inherits(Filter, _React$Component);
  function Filter() {
    _classCallCheck(this, Filter);
    var _this = _possibleConstructorReturn(this, (Filter.__proto__ || Object.getPrototypeOf(Filter)).call(this));
    _this.state = {
      filters: []
    };
    return _this;
  }
  _createClass(Filter, [{
    key: 'add',
    value: function add(attribute, value) {
      var filter = {
        attribute: attribute,
        value: value
      };
      var filters = [].concat(_toConsumableArray(this.state.filters), [Object.assign({}, filter)]);
      this.setState(function () {
        return {
          filters: filters
        };
      });
    }
  }, {
    key: 'update',
    value: function update(attribute, value) {
      var filter = {
        attribute: attribute,
        value: value
      };
      var index = (0, _lodash.findIndex)(this.state.filters, function (f) {
        return f.attribute === attribute;
      });
      var filters = index !== -1 ? [].concat(_toConsumableArray(this.state.filters.slice(0, index)), [Object.assign({}, filter)], _toConsumableArray(this.state.filters.slice(index + 1))) : [].concat(_toConsumableArray(this.state.filters), [Object.assign({}, filter)]);
      this.setState(function () {
        return {
          filters: filters
        };
      });
    }
  }, {
    key: 'remove',
    value: function remove(attribute, value) {
      var index = value ? (0, _lodash.findIndex)(this.state.filters, function (f) {
        return f.attribute === attribute && f.value === value;
      }) : (0, _lodash.findIndex)(this.state.filters, function (f) {
        return f.attribute === attribute;
      });
      this.setState(function (state) {
        return {
          filters: [].concat(_toConsumableArray(state.filters.slice(0, index)), _toConsumableArray(state.filters.slice(index + 1)))
        };
      });
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.setState(function () {
        return {
          filters: []
        };
      });
    }
  }, {
    key: 'filteredItems',
    value: function filteredItems() {
      var _this2 = this;
      if (this.state.filters.length > 0) {
        var filteredArrays = this.state.filters.map(function (f) {
          var comparison = function comparison(item) {
            return item[f.attribute] === f.value || item[f.attribute].includes(f.value);
          };
          return _this2.props.items.filter(function (item) {
            return comparison(item);
          });
        });
        return _lodash.intersection.apply(undefined, _toConsumableArray(filteredArrays));
      }
      return this.props.items;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('form', {
        className: 'filter ' + this.props.className
      }, this.props.children(this, this.filteredItems()));
    }
  }]);
  return Filter;
}(_react2.default.Component);
Filter.defaultProps = {
  className: '',
  items: []
};
Filter.propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.func.isRequired,
  items: _propTypes2.default.arrayOf(_propTypes2.default.shape({}))
};
exports.default = Filter;